/**
 * Feature-specific query keys for user data
 * Co-located with the user feature for better organization
 */

export const userQueryKeys = {
  all: ["user"] as const,
  donationSummary: () => ["user", "donationSummary"] as const,
} as const;